import React from 'react';
import SEO from 'react-seo-component';
import { useQuery } from '@apollo/react-hooks';

import './mobile-brand-product-list-style.scss';

import MobileProductListPageSkeleton from '@src/componentsNew/Skeleton/mobile/page/MobileProductListPageSkeleton';
import TopButton from '@src/componentsNew/Buttons/TopButton/TopButton';
import MobileBrandProductListTemplate from '@src/componentsNew/ProductListTemplate/Brand/MobileBrandProductListTemplate';

import { BRAND } from '@src/components/ProductPage/BrandPage/queries';

import useScroll from '@src/hooks/useScroll';
import { getGraphqlIdFromDBId } from '@utils';

const MobileBrandProductListPage = ({ match }) => {
  const { isScrolled, scrollTop } = useScroll();
  const brandId = getGraphqlIdFromDBId(match.params.id, 'Brand');

  const { data, loading } = useQuery(BRAND, {
    variables: {
      id: brandId,
    },
  });

  if (loading) {
    return <MobileProductListPageSkeleton type="brand" />;
  }

  return data?.brand ? (
    <div id="mobile-brand-product-list-wrapper">
      <SEO
        title={data?.brand?.seoTitle ?? ''}
        description={data?.brand?.seoDescription ?? ''}
        titleTemplate={''}
        titleSeparator={`-`}
        pathname={`https://maccaron.in${data?.brand?.url}`}
        siteLanguage="en"
        siteLocale="en_GB"
        twitterUsername=""
      />

      <MobileBrandProductListTemplate
        brandName={data?.brand?.name}
        brandTnc={data?.brand?.tnc}
        brandImages={data?.brand?.images}
        brandCategories={data?.brand?.categories?.edges}
        currentBrandGraphqlId={brandId}
      />

      {isScrolled && <TopButton isMobile={true} onClick={scrollTop} />}
    </div>
  ) : null;
};

export default MobileBrandProductListPage;
